import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ProjectList from "../components/Compte/ProjectList";
import ProjectForm from "../components/Compte/ProjectForm";
import UserProfile from "../components/Compte/UserProfile";
import { LogOut } from "lucide-react";
import config from "../config";

const AdSysteme = () => {
  const [activeTab, setActiveTab] = useState("projectList");
  const [loading, setLoading] = useState(false);
  const { lang } = useParams();
  const navigate = useNavigate();

  const handleLogout = async () => {
    setLoading(true);
    try {
      await fetch(`${config.API_BASE_URL}/api/auth/logout`, {
        method: "POST",
        credentials: "include",
      });
      navigate(`/${lang}/`);
    } catch (error) {
      console.error("Erreur lors de la déconnexion:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col lg:flex-row h-screen w-full dark:text-light py-5 overflow-hidden">
      <main className="flex-1 p-4 sm:p-6 md:p-8 w-full overflow-y-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => setActiveTab("projectList")}
              className={`px-4 py-2 text-sm sm:text-base lg:text-lg font-semibold rounded-lg transition shadow ${
                activeTab === "projectList"
                  ? "bg-deepblue text-white"
                  : "bg-gray-200 dark:bg-accent text-gray-800 dark:text-white"
              }`}
            >
              Choisir les projets
            </button>
            <button
              onClick={() => setActiveTab("creatProg")}
              className={`px-4 py-2 text-sm sm:text-base lg:text-lg font-semibold rounded-lg transition shadow ${
                activeTab === "creatProg"
                  ? "bg-deepblue text-white"
                  : "bg-gray-200 dark:bg-accent text-gray-800 dark:text-white"
              }`}
            >
              Créer un projet
            </button>
            <button
              onClick={() => setActiveTab("modifyUser")}
              className={`px-4 py-2 text-sm sm:text-base lg:text-lg font-semibold rounded-lg transition shadow ${
                activeTab === "modifyUser"
                  ? "bg-deepblue text-white"
                  : "bg-gray-200 dark:bg-accent text-gray-800 dark:text-white"
              }`}
            >
              Gérer mes infos
            </button>
          </div>

          {/* Logout */}
          <button
            onClick={handleLogout}
            disabled={loading}
            className="flex items-center justify-center gap-2 w-full sm:w-auto bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition"
          >
            <LogOut size={18} />
            {loading ? "Déconnexion..." : "Se déconnecter"}
          </button>
        </div>

        {/* Content */}
        <div className="p-2 sm:p-4">
          {activeTab === "projectList" && <ProjectList />}
          {activeTab === "creatProg" && <ProjectForm />}
          {activeTab === "modifyUser" && <UserProfile />}
        </div>
      </main>
    </div>
  );
};

export default AdSysteme;
